import React from 'react';
import { useHistory } from 'react-router-dom';
import './RoleSelectionModal.css';

interface RoleSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  shortlistedCount?: number;
}

const RoleSelectionModal: React.FC<RoleSelectionModalProps> = ({ isOpen, onClose, shortlistedCount = 0 }) => {
  const history = useHistory();

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleRoleSelect = (role: 'admin' | 'agency') => {
    // Store selected role preference or items if needed
    if (role === 'admin') {
      history.push('/login?role=admin');
    } else {
      history.push('/agency/login');
    }
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="role-modal-content glass" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>&times;</button>
        
        <div className="modal-header">
          <div className="badge gold-badge">THE TRANSITION</div>
          <h2>Start Your Wedding Journey</h2>
          {shortlistedCount > 0 && (
            <p className="items-context">
              We've saved your <strong>{shortlistedCount} shortlisted items</strong>. 
              Choose how you want to plan to bring them to life!
            </p>
          )}
        </div>

        <div className="role-options">
          <div className="role-card admin-card" onClick={() => handleRoleSelect('admin')}>
            <div className="role-icon">💍</div>
            <h3>I am Planning My Own Wedding</h3>
            <p>Perfect for couples and families. Manage your budget, guests, and vendors in one place.</p>
            <button className="role-btn">Start as Wedding Admin</button>
          </div>

          <div className="role-divider">
            <span>OR</span>
          </div>

          <div className="role-card agency-card" onClick={() => handleRoleSelect('agency')}>
            <div className="role-icon">💼</div>
            <h3>I am a Professional Planner</h3>
            <p>For agencies and independent planners. Manage multiple clients and professional vendor networks.</p>
            <button className="role-btn">Login to Agency Portal</button>
          </div>
        </div>

        <div className="modal-footer">
          <p>Not sure? <span className="link-text" onClick={onClose}>Continue browsing for now</span></p>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectionModal;
